export const iconColorClass = (iconClass: string | null | undefined) => {
  if (!iconClass) return "tw:text-muted-foreground"
  if (iconClass.includes("text-warning")) return "tw:text-yellow-500"
  if (iconClass.includes("text-success")) return "tw:text-green-600"
  if (iconClass.includes("text-danger")) return "tw:text-red-600"
  if (iconClass.includes("text-info")) return "tw:text-sky-500"
  if (iconClass.includes("text-primary")) return "tw:text-blue-700"
  return "tw:text-muted-foreground"
}
